import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig.js';

export class LogisticaService {
    getViajes() {
        return axios.get('assets/data/logistica.json').then((res) => res.data.data);
    }

    async consultarPorRangoDeFEchas(fechaInicio, fechaFin) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        let config2 = {

            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fechaInicio: fechaInicio,
                fechaFin: fechaFin
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/fecha-planificacion`, config2).then(res => res.data);
    }

    async consultarPorRangoDeFEchasYTipoViaje(fechaInicio, fechaFin, tipoViajeCodigo) {

        let codigoViaje = tipoViajeCodigo.codigo;
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        let config2 = {

            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fechaInicio: fechaInicio,
                fechaFin: fechaFin,
                tipoViajeCodigo: codigoViaje
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/fecha-planificacion/tipo-viaje-codigo`, config2).then(res => res.data);
    }

    async consultarFechaPlanificacionTipoViaje(fechaInicio, fechaFin, tipoViajeCodigo) {

        let codigoViaje = tipoViajeCodigo.codigo;
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        let config2 = {

            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fechaInicio: fechaInicio,
                fechaFin: fechaFin,
                tipoViajeCodigo: codigoViaje
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/grafico/pie/fecha-planificacion-tipo-viaje`, config2).then(res => res.data);
    }

    async getBookingPieFiltrosLogisticos(anio, mes, semana, diaSemana, tipoViaje) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana,
                tipoViajeCodigo: tipoViaje
            }
        }

        return await axios.get(`${BASE_URL}/booking/consultar/grafico/pie/filtro-logistico`,
            config2
        ).then(res => res.data.data);
    }

    async getBookingMesFiltrosLogisticos(anio, mes, semana, diaSemana, tipoViaje) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana,
                tipoViajeCodigo: tipoViaje
            }
        }

        return await axios.get(`${BASE_URL}/booking/consultar/grafico/barra/mes/filtro-logistico`,
            config2
        ).then(res => res.data.data);
    }

    // Agregado del grafico "Viajes por Mes" respetando filtros finos (endpoint nuevo, aparte).
    async getBookingMesFiltrosFinos(anio, mes, semana, diaSemana, tipoViaje, categoria, barco, zona, anden) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana,
                tipoViajeCodigo: tipoViaje,
                categoria: categoria || undefined,
                barco: barco || undefined,
                zona: zona || undefined,
                anden: anden ? true : undefined
            }
        }

        return await axios.get(`${BASE_URL}/booking/consultar/grafico/barra/mes/filtro-logistico-fino`,
            config2
        ).then(res => res.data.data);
    }

    // Agregado del grafico "Viajes por Semana" respetando filtros finos (endpoint nuevo, aparte).
    async getBookingSemanaFiltrosFinos(anio, mes, semana, diaSemana, tipoViaje, categoria, barco, zona, anden) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana,
                tipoViajeCodigo: tipoViaje,
                categoria: categoria || undefined,
                barco: barco || undefined,
                zona: zona || undefined,
                anden: anden ? true : undefined
            }
        }

        return await axios.get(`${BASE_URL}/booking/consultar/grafico/barra/semana/filtro-logistico-fino`,
            config2
        ).then(res => res.data.data);
    }

    async getBookingSemanaFiltrosLogisticos(anio, mes, semana, diaSemana, tipoViaje) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana,
                tipoViajeCodigo: tipoViaje
            }
        }

        return await axios.get(`${BASE_URL}/booking/consultar/grafico/barra/semana/filtro-logistico`,
            config2
        ).then(res => res.data.data);
    }

    async getBookingDiaFiltrosLogisticos(anio, mes, semana, diaSemana) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana
            }
        }

        return await axios.get(`${BASE_URL}/booking/consultar/grafico/barra/dia/filtro-logistico `,
            config2
        ).then(res => res.data.data);
    }

    async getViajesPorBookingFiltrosLogisticos(anio, mes, semana, diaSemana) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/booking/filtro-logistico`,
            config2
        ).then(res => res.data.data);
    }

    async getViajesPorBookingFiltrosLogisticos2(anio, mes, semana, diaSemana, tipoViaje) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana,
                tipoViaje: tipoViaje
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/rep-viaje/filtro-logistico` ,
            config2
        ).then(res => res.data.data);
    }



    async consultarFechaPlanificacionSemana(fechaInicio, fechaFin, tipoViajeCodigo) {

        let codigoViaje = tipoViajeCodigo.codigo;
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        let config2 = {

            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fechaInicio: fechaInicio,
                fechaFin: fechaFin,
                tipoViajeCodigo: codigoViaje
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/grafico/barra/semana/fecha-planificacion-tipo-viaje`, config2).then(res => res.data);
    }

    async consultarFechaPlanificacionMes(fechaInicio, fechaFin, tipoViajeCodigo) {

        let codigoViaje = tipoViajeCodigo.codigo;
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        let config2 = {

            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fechaInicio: fechaInicio,
                fechaFin: fechaFin,
                tipoViajeCodigo: codigoViaje
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/grafico/barra/mes/fecha-planificacion-tipo-viaje`, config2).then(res => res.data);
    }

    async consultarFechaPlanificacionDia(fechaInicio, fechaFin, tipoViajeCodigo) {

        let codigoViaje = tipoViajeCodigo.codigo;
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        let config2 = {

            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {
                fechaInicio: fechaInicio,
                fechaFin: fechaFin,
                tipoViajeCodigo: codigoViaje
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/grafico/barra/dia/fecha-planificacion-tipo-viaje`, config2).then(res => res.data);
    }

    async consultarViajeIdParaActualizar(viajeId) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        let config2 = {

            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            }
        }

        return await axios.get(`${BASE_URL}/viaje/actualizar/fecha-viaje/google/viaje/${viajeId}`, config2).then(res => res.data);
    }

    async getRepViajesPorFiltrosLogisticosYBooking(anio, mes, semana, diaSemana, tipoViaje, booking) {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            },
            params: {

                anio: anio,
                mes: mes,
                semana: semana,
                diaSemana: diaSemana,
                tipoViaje: tipoViaje,
                booking: booking
            }
        }

        return await axios.get(`${BASE_URL}/viaje/consulta/rep-viaje/filtro-logistico-booking`,
            config2
        ).then(res => res.data.data);
    }



}
